<template>
  <section class="section">
    <b-loading
      :is-full-page="true"
      :active.sync="loading"
      :can-cancel="false"
    ></b-loading>
    <div
      v-if="!error && !loading"
      class="container"
    >
      <TituloPrincipal :titulo="titulo" />
      <b-loading
        :is-full-page="true"
        :active.sync="reloading"
        :can-cancel="false"
      ></b-loading>
      <!-- Seccion de mensajes con variantes para cada tipo de pedido -->
      <div class="columns">
        <div class="column"
          v-if="successPedidoMessage && successPedidoMessage !== ''"
          >
          <b-message
            :closable="false"
            type="is-success"
            has-icon
          >{{successPedidoMessage}}</b-message>
        </div>
        <div class="column"
          v-if="infoPedidoMessage && infoPedidoMessage !== ''"
          >
          <b-message
            :closable="false"
            type="is-info"
            has-icon
          >{{infoPedidoMessage}}</b-message>
        </div>
        <div class="column"
          v-if="alertPedidoMessage && alertPedidoMessage !== ''"
          >
          <b-message
            :closable="false"
            type="is-danger"
            has-icon
          >{{alertPedidoMessage}}</b-message>
        </div>
      </div>
      <!-- Seccion de carga de datos envío -->
      <div
        class="box"
        v-if="pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad"
        >
        <div class="title is-4">Datos de Envío</div>
        <div class="columns is-multiline is-centered">
          <div class="column is-5">
            <b-field
              label="Codigo Postal"
              :type="{'is-danger': errors.has('codigo postal')}"
              :message="errors.first('codigo postal')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                v-model="pedido.datosEnvio.codigoPostal"
                name="codigo postal"
                v-validate="{ required: true, max: 255, min: 4, numeric: true }"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
            <b-field
              label="Calle"
              :type="{'is-danger': errors.has('calle')}"
              :message="errors.first('calle')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                v-model="pedido.datosEnvio.calle"
                name="calle"
                v-validate="{ required: true, max: 255, min: 4, regex: /^([a-zA-Z]|\d|á|é|í|ó|ú|[ ]|ñ|ü)+$/ }"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
            <b-field
              label="Altura"
              :type="{'is-danger': errors.has('altura')}"
              :message="errors.first('altura')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                v-model="pedido.datosEnvio.altura"
                name="altura"
                v-validate="{ required: true, max: 255, min:1, numeric: true }"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
            <b-field
              label="Piso"
              :type="{'is-danger': errors.has('piso')}"
              :message="errors.first('piso')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                v-model="pedido.datosEnvio.piso"
                name="piso"
                v-validate="{ required: false, max: 255, regex: /^([a-zA-Z]|\d|á|é|í|ó|ú|[ ]|ñ|ü)+$/ }"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
            <b-field
              label="Departamento"
              :type="{'is-danger': errors.has('departamento')}"
              :message="errors.first('departamento')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                v-model="pedido.datosEnvio.departamento"
                name="departamento"
                v-validate="{ required: false, max: 255, regex: /^([a-zA-Z]|\d|á|é|í|ó|ú|[ ]|ñ|ü)+$/ }"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
          </div>
          <div class="column is-7">
                <div class="box">
            <div class="columns is-multiline">
              <div class="column is-6">
                  <b-field
                    label="Fecha de Entrega"
                    :type="{'is-danger': errors.has('fecha de entrega')}"
                    :message="errors.first('fecha de entrega')"
                  >
                    <b-input
                    type="date"
                    :disabled="!habilitarFormularioEnvio"
                    placeholder="Seleccionar"
                      name="fecha de entrega"
                      v-model="pedido.datosEnvio.fechaEntrega"
                      v-validate="{ required: true, date_format: 'yyyy-MM-dd', date_between: [constraintsfechaEntrega.fechaMinimaVeeValidate, constraintsfechaEntrega.fechaMaximaVeeValidate] }"
                      :min="constraintsfechaEntrega.fechaMinima"
                      :max="constraintsfechaEntrega.fechaMaxima"
                    />
                  </b-field>
                </div>
              <div class="column is-6">
                <b-field
                  label="Horario Entrega (Comercio)"
                  :type="{'is-danger': errors.has('turno')}"
                  :message="errors.first('turno')">
                  <b-select
                    placeholder="Seleccionar Turno"
                    :disabled="!habilitarFormularioEnvio"
                    v-model="pedido.datosEnvio.turno"
                    name="turno"
                    v-validate="{ required: true }"
                    v-on:keyup.enter="agregarDatosEnvio()"
                    >
                      <option
                          v-for="nombreTurno in $constantes.pedidos.turnosEntrega"
                          :value="nombreTurno"
                          :key="nombreTurno">
                          {{ nombreTurno }}
                      </option>
                  </b-select>
              </b-field>
              </div>
              <div class="column is-12">
                <b-field
              label="Observaciones Entrega"
              :type="{'is-danger': errors.has('observaciones')}"
              :message="errors.first('observaciones')"
            >
              <b-input
                :disabled="!habilitarFormularioEnvio"
                placeholder="Recomendación para horario de entrega, particularidades del domicilio, etc."
                v-model="pedido.datosEnvio.observaciones"
                name="observaciones"
                type="textarea"
                v-validate="{ required: false, max: 255}"
                v-on:keyup.enter="agregarDatosEnvio()"
              />
            </b-field>
              </div>
              </div>
            </div>
            <div class="box">
              <b-field
                label="Teléfono"
                :type="{'is-danger': errors.has('teléfono')}"
                :message="errors.first('teléfono')"
              >
                <b-input
                  :disabled="!habilitarFormularioEnvio"
                  v-model="pedido.datosEnvio.telefono"
                  type="tel"
                  name="teléfono"
                  v-validate="{ required: true, min: 7, max: 255, regex: /^([[0-9 +]|[(]|[)]|[-])+$/ }"
                  v-on:keyup.enter="agregarDatosEnvio()"
                />
              </b-field>
              <b-field
                label
                :type="{'is-danger': errors.has('posee whatsapp')}"
                :message="errors.first('posee whatsapp')"
              >
                <b-checkbox
                  :disabled="!habilitarFormularioEnvio"
                  v-model="pedido.datosEnvio.tieneWhatsapp"
                  name="posee whatsapp"
                  v-validate="{ required: false }"
                >
                  Posee Whatsapp
                </b-checkbox>
              </b-field>
            </div>
          </div>
          <div class="column is-3">

            <b-button
              v-if="habilitarFormularioEnvio"
              type="is-primary"
              @click="agregarDatosEnvio()"
            >
              Guardar
            </b-button>
          </div>
        </div>
      </div>

      <!-- Seccion box con datos del pedido -->
      <div class="box">
        <div class="columns is-multiline is-centered">
          <div class="column is-12">
            <b-button
              icon-left="refresh"
              :loading="reloading"
              @click="recuperarPedido()"
            >Actualizar</b-button>
          </div>
        </div>

        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Tipo</p>
              <p class="title is-4">
                <b-tag type="is-primary">{{pedido.tipo | eliminarGuionesBajos }}</b-tag>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Fecha Emisión</p>
              <p class="title is-4">
                <span class="tag is-primary">{{ pedido.fechaEmision ? new Date(pedido.fechaEmision).toLocaleString() : '' }}</span>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">PRODUCTO</p>
              <p class="title is-4">
                 <b-tag
                  type="is-primary"
                >{{pedido.nombreCompleto}}</b-tag>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Cantidad de Fotos</p>
              <p class="title is-4">{{pedido.cantidadFotos}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Estado</p>
              <p class="title is-4">
                <template
                  v-if="pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad &&
                        pedido.preferenciaCompra && pedido.preferenciaCompra.shipment
                        && pedido.estado === this.$constantes.pedidos.estados.CERRADO">
                  <b-tag
                    type="is-primary"
                    v-if="pedido.preferenciaCompra.shipment.status === 'shipped'"
                    >
                    EN CAMINO
                  </b-tag>
                  <b-tag
                    type="is-primary"
                    v-if="pedido.preferenciaCompra.shipment.status === 'delivered'"
                    >
                    ENTREGADO
                  </b-tag>
                  <b-tag
                    type="is-primary"
                    v-if="pedido.preferenciaCompra.shipment.status === 'pending'"
                    >
                    CERRADO
                  </b-tag>
                </template>
                <b-tag v-else type="is-primary">{{pedido.estado | eliminarGuionesBajos }}</b-tag>
              </p>
              <b-button
                class="boton-pagar-pedido"
                v-if="pedido.estado === this.$constantes.pedidos.estados.PENDIENTE_PAGO"
                tag="a"
                :href="pedido.preferenciaCompra.init_point"

                type="is-warning"
              >Pagar Pedido</b-button>
            </div>
          </div>
        </nav>
        <div class="is-hidden-mobile">
          <b-steps
            v-if="pedido.tipo === this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad"
            v-model="activeStep"
            size="is-small"
            :has-navigation="false"
          >
            <b-step-item label="Creado"></b-step-item>
            <b-step-item label="Procesando"></b-step-item>
            <b-step-item label="Para Retiro"></b-step-item>
            <b-step-item label="Cerrado"></b-step-item>
          </b-steps>

          <b-steps
            v-if="pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad ||
                  pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad"
            v-model="activeStep"
            size="is-small"
            :has-navigation="false"
          >
            <b-step-item label="Pendiente Pago"></b-step-item>
            <b-step-item label="Creado"></b-step-item>
            <b-step-item label="Procesando"></b-step-item>
            <b-step-item label="Envío Pendiente"></b-step-item>
            <b-step-item label="Cerrado"></b-step-item>
          </b-steps>

          <b-steps
            v-if="pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad"
            v-model="activeStep"
            size="is-small"
            :has-navigation="false"
          >
            <b-step-item label="Pendiente Pago"></b-step-item>
            <b-step-item label="Creado"></b-step-item>
            <b-step-item label="Procesando"></b-step-item>
            <b-step-item label="Para Retiro"></b-step-item>
            <b-step-item label="Cerrado"></b-step-item>
          </b-steps>
        </div>
        <b-message
          v-if="pedido.observaciones && pedido.observaciones !== ''"
          title="Observaciones"
          :closable="false"
          type="is-primary"
          has-icon
        >{{pedido.observaciones}}</b-message>
        <div
          class="box has-background-white-ter"
          v-if="pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad
           && pedido.preferenciaCompra && pedido.preferenciaCompra.shipment"
        >
          <div class="title is-4">Envío</div>
          <nav class="level">
            <div class="level-item has-background-light">
              <div>
                <p class="heading">Ciudad</p>
                  <p class="title is-4">
                    {{pedido.preferenciaCompra.shipment.receiver_address.city.name}} - {{pedido.preferenciaCompra.shipment.receiver_address.zip_code}}
                  </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Calle</p>
                <p class="title is-4">
                  {{pedido.preferenciaCompra.shipment.receiver_address.street_name}}
                </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Numero</p>
                <p class="title is-4">
                  {{pedido.preferenciaCompra.shipment.receiver_address.street_number}}
                </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Piso - Dpto</p>
                <p class="title is-4">
                  {{pedido.preferenciaCompra.shipment.receiver_address.floor}} - {{pedido.preferenciaCompra.shipment.receiver_address.apartment}}
                </p>
              </div>
            </div>
          </nav>
        </div>
      </div>

    </div>
    <div
      v-if="error && !loading"
      class="container"
    >
      <TituloPrincipal titulo="Error" />
      <b-notification
        type="is-danger"
        has-icon
        aria-close-label="Cerrar"
        role="alert"
      >Hubo un problema y no encontramos el pedido indicado, por favor vuelva a intentarlo</b-notification>
    </div>
  </section>
</template>

<style>
@keyframes kreep {
    0% {-webkit-transform: scale(1.1,.9);
        transform: scale(1.1,.9);}
   50% { -webkit-transform: scale(.9,1.1) translateY(-.5rem)}
   70% { -webkit-transform: scale(1);
         transform: scale(1);}
}

.boton-pagar-pedido {
  margin: 0.3rem;
  display: inline-block;
  /*name-duration-function(ease,eas-in,linear)-delay-count-direction */
  animation: kreep 0.7s ease 2s infinite alternate;
}
.boton-pagar-pedido:hover {
  animation: none;
}
</style>

<script>
import TituloPrincipal from '@/components/TituloPrincipal'
import moment from 'moment-timezone'

const mensajeDemoraEntrega = '¡Importante! Se le enviará un mail cuando su pedido este listo para ser retirado dentro de las 24 Hs (polaroid, bastidores/collage y calendarios hasta 48 hs). '

export default {
  name: 'PedidoEstado',
  data () {
    return {
      titulo: '',
      id: '',
      resultado: null,
      pedido: null,
      error: false,
      loading: true,
      reloading: false,
      activeStep: 0,
      constraintsfechaEntrega: {
        fechaMinima: null,
        fechaMaxima: null
      },
      habilitarFormularioEnvio: false
    }
  },
  computed: {
    infoPedidoMessage () {
      let message = ''
      switch (this.pedido.tipo) {
        case this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad:
          message += 'Recordá comunicarte con el local para coordinar con el laboratorio el pago y la entrega del pedido.'
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad:
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad:
          if (this.habilitarFormularioEnvio) {
            message += 'Cargá aquí debajo los datos para que te enviemos el pedido a tu casa. No olvides elegir fecha y turno de entrega.'
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad:
          break
      }
      return message
    },
    successPedidoMessage () {
      let message = 'Tu fotos se subieron correctamente.'
      switch (this.pedido.tipo) {
        case this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad:
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad:
          if (this.pedido.estado !== this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'El pago fue procesado correctamente. '
          }
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.PENDIENTE_PAGO:
            case this.$constantes.pedidos.estados.CREADO:
            case this.$constantes.pedidos.estados.PROCESANDO:
              message += mensajeDemoraEntrega
              break
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad:
          if (this.pedido.estado !== this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'El pago fue procesado correctamente. '
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad:
          if (this.pedido.estado !== this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'El pago fue procesado correctamente. '
          }
          break
      }
      return message
    },
    alertPedidoMessage () {
      let message = ''
      switch (this.pedido.tipo) {
        case this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad:
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad:
          if (this.pedido.estado === this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'Efectuá el pago del pedido desde el boton de "Pagar Pedido" más abajo. '
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad:
          if (this.pedido.estado === this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'Efectuá el pago del pedido desde el boton de "Pagar Pedido" más abajo. '
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad:
          if (this.pedido.estado === this.$constantes.pedidos.estados.PENDIENTE_PAGO) {
            message += 'Efectuá el pago del pedido desde el boton de "Pagar Pedido" más abajo. '
          }
          break
      }
      return message
    }
  },
  components: {
    TituloPrincipal
  },
  methods: {
    mostrarMensajeInicial () {
      if (this.resultado !== null) {
        let mensaje = ''
        let mensajePorDemoraEntrega = ''
        if (this.pedido.tipo === this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad) {
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.PENDIENTE_PAGO:
            case this.$constantes.pedidos.estados.CREADO:
            case this.$constantes.pedidos.estados.PROCESANDO:
              mensajePorDemoraEntrega += mensajeDemoraEntrega
              break
          }
        }
        switch (this.resultado) {
          case 'success':
            mensaje += 'Tu pago ha sido procesado correctamente. ' + mensajePorDemoraEntrega
            this.$buefy.dialog.alert({
              title: 'Listo',
              message: mensaje,
              type: 'is-success',
              hasIcon: true,
              icon: 'check',
              iconPack: 'mdi',
              confirmText: 'Aceptar'
            })
            break
          case 'pending':
            mensaje += 'Tu pago está siendo procesando, en breve estaremos actualizando el estado del pedido. ' + mensajePorDemoraEntrega
            this.$buefy.dialog.alert({
              title: 'Procesando Pago',
              message: mensaje,
              type: 'is-warning',
              hasIcon: true,
              icon: 'information',
              iconPack: 'mdi',
              confirmText: 'Aceptar'
            })
            break
          case 'failure':
            mensaje += 'Hubo un error procesando tu pago, por favor intenta nuevamente desde el botón de "pagar pedido" en esta pantalla. ' + mensajePorDemoraEntrega
            this.$buefy.dialog.alert({
              title: 'Error',
              message: mensaje,
              type: 'is-danger',
              hasIcon: true,
              icon: 'close-circle-outline',
              iconPack: 'mdi',
              confirmText: 'Aceptar'
            })
            break
        }
      }
    },
    setupPedido () {
      this.mostrarMensajeInicial()
      // Si no tiene datos envio, se los agrega
      if (this.pedido.datosEnvio === null) {
        this.habilitarFormularioEnvio = true
        this.pedido.datosEnvio = {
          codigoPostal: null,
          calle: null,
          altura: null,
          piso: null,
          departamento: null,
          telefono: null,
          tieneWhatsapp: false,
          fechaEntrega: null,
          turno: null,
          observaciones: null
        }
      } else {
        this.habilitarFormularioEnvio = false
        this.pedido.datosEnvio.fechaEntrega = moment(this.pedido.datosEnvio.fechaEntrega).format('YYYY-MM-DD')
      }
      let fechaMinima = moment(this.pedido.subidaUltimaFoto).add(Number(process.env.VUE_APP_DEMORA_CADETE_HS), 'hours')
      fechaMinima = fechaMinima.tz('America/Buenos_Aires').format('YYYY-MM-DD')
      let fechaMaxima = moment(this.pedido.subidaUltimaFoto).add(Number(process.env.VUE_APP_POSTERGACION_MAX_CADETE_HS), 'hours')
      fechaMaxima = fechaMaxima.tz('America/Buenos_Aires').format('YYYY-MM-DD')

      this.constraintsfechaEntrega = {
        fechaMinima,
        fechaMaxima,
        fechaMinimaVeeValidate: moment(fechaMinima, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD'),
        fechaMaximaVeeValidate: moment(fechaMaxima, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      }
      switch (this.pedido.tipo) {
        case this.$constantes.pedidos.tipos.TRADICIONAL.textoEntidad: // tradicional
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.CREADO:
              this.activeStep = 0
              break
            case this.$constantes.pedidos.estados.PROCESANDO:
              this.activeStep = 1
              break
            case this.$constantes.pedidos.estados.PARA_RETIRO:
              this.activeStep = 2
              break
            case this.$constantes.pedidos.estados.CERRADO:
              this.activeStep = 3
              break
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE.textoEntidad: // paga online con envio
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.PENDIENTE_PAGO:
              this.activeStep = 0
              break
            case this.$constantes.pedidos.estados.CREADO:
              this.activeStep = 1
              break
            case this.$constantes.pedidos.estados.PROCESANDO:
              this.activeStep = 2
              break
            case this.$constantes.pedidos.estados.PARA_RETIRO:
              this.activeStep = 3
              break
            case this.$constantes.pedidos.estados.CERRADO:
              this.activeStep = 4
              break
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_MERCADO_ENVIOS.textoEntidad: // paga online sin envio
          if (this.pedido.preferenciaCompra && this.pedido.preferenciaCompra.shipment) {
            this.pedido.preferenciaCompra.shipment = JSON.parse(this.pedido.preferenciaCompra.shipment)
          }
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.PENDIENTE_PAGO:
              this.activeStep = 0
              break
            case this.$constantes.pedidos.estados.CREADO:
              this.activeStep = 1
              break
            case this.$constantes.pedidos.estados.PROCESANDO:
              this.activeStep = 2
              break
            case this.$constantes.pedidos.estados.ENVIO_PENDIENTE:
              this.activeStep = 3
              break
            case this.$constantes.pedidos.estados.CERRADO:
              this.activeStep = 4
              break
          }
          break
        case this.$constantes.pedidos.tipos.COMPRA_ONLINE_CON_ENVIO.textoEntidad: // paga online con envio local
          switch (this.pedido.estado) {
            case this.$constantes.pedidos.estados.PENDIENTE_PAGO:
              this.activeStep = 0
              break
            case this.$constantes.pedidos.estados.CREADO:
              this.activeStep = 1
              break
            case this.$constantes.pedidos.estados.PROCESANDO:
              this.activeStep = 2
              break
            case this.$constantes.pedidos.estados.ENVIO_PENDIENTE:
              this.activeStep = 3
              break
            case this.$constantes.pedidos.estados.CERRADO:
              this.activeStep = 4
              break
          }
          break
      }
    },
    recuperarPedido () {
      this.reloading = true

      this.$apiService
        .getPedido(this.id)
        .then(response => {
          this.pedido = response.data
          this.setupPedido()
        })
        .catch(error => {
          this.error = true
          this.mensajeErrorAxios(error, this)
        })
        .finally(something => {
          this.loading = false
          this.reloading = false
        })
    },
    prepararPedidoParaEdit (pedido) {
      const copiaPedido = {
        '@id': pedido['@id'],
        '@type': pedido['@type'],
        id: pedido.id,
        datosEnvio: pedido.datosEnvio
      }
      return copiaPedido
    },
    agregarDatosEnvio () {
      const componenteVue = this
      // Valida el form
      this.$validator.validateAll().then(result => {
        // Si esta todo bien realiza el llamado en la api
        if (result) {
          this.$buefy.dialog.confirm({
            title: 'Datos de Envío',
            message: '¿Está seguro que desea guardar los datos de envío?',
            cancelText: 'Cancelar',
            confirmText: 'Guardar',
            type: 'is-success',
            onConfirm: () => {
              // Ejecuta llamdo sobre api
              this.reloading = true
              this.$apiService.editPedido(this.prepararPedidoParaEdit(this.pedido))
                .then(response => {
                  this.$buefy.toast.open({
                    message: 'Datos editados correctamente',
                    type: 'is-success'
                  })
                  componenteVue.pedido = response.data
                  componenteVue.setupPedido()
                })
                .catch(error => {
                  componenteVue.mensajeErrorAxios(error, componenteVue)
                })
                .finally(something => {
                  this.loading = false
                  this.reloading = false
                })
            }
          })
        } else { // Sino renderiza toast con error
          this.isLoading = false
          this.$buefy.toast.open({
            message: 'Revise los datos',
            type: 'is-danger',
            position: 'is-top'
          })
        }
      })
    }
  },
  created () {
    this.id = this.$route.params.id
    this.titulo = `Pedido Nº ${this.id}`
    if (this.$route.query.resultado) {
      this.resultado = this.$route.query.resultado
    }

    this.recuperarPedido()
  },
  mounted () {
    const dict = {
      custom: {
        calle: {
          regex: 'Solo se pueden usar letras, acentos, espacios y números'
        },
        departamento: {
          regex: 'Solo se pueden usar letras, acentos, espacios y números'
        },
        piso: {
          regex: 'Solo se pueden usar letras, acentos, espacios y números'
        },
        teléfono: {
          regex:
            'Solo se pueden usar números, paréntesis, espacios y el signo +'
        },
        'fecha de entrega': {
          date_between:
            'Fecha fuera de límites.'
        }
      }
    }

    this.$validator.localize('es', dict)
  }
}
</script>
